module.exports = __webpack_public_path__ + "img/abafooter.6504d277.png";